import React, { useState, useContext, useEffect } from "react";

import {
  Card,
  Input,
  Select,
  Dropdown,
  FormGroup,
  RadioGroup,
  FormFooter,
  ContentBlock,
  Icon,
  StatusDot,
  CardBanner,
  ButtonActions
} from "xsolla-uikit";


import './cards.css';



import { Switch, Route } from "react-router-dom";

import Webflow from "webflow-api";

import styled, { css } from "styled-components";
import { defaultSolutions } from "../../data/defaultSolutions";
import { xsollaProducts } from '../../data/xsollaProducts';
import { PAsolutionCards } from "./PAsolutionCards";

export default function PAsolutionsNew({
  limit,
  shown = true,
  all = false,
  hardlimit,
  solutions = defaultSolutions
}) {
  const [uiState, setUiState] = useState({
    shown: shown,
    all: all
  });

  useEffect(() => {
    console.log("uiState = ", uiState);
  }, [uiState]);



  return (
    <FormGroup>
      {/* <div
          className="p_content-block p_content-block--brand"
          style={{ cursor: uiState.shown ? "inherit" : "pointer" }}
        > */}
      <div
        className="p_modal_c p_head--solut"
        onClick={e => {
          e.stopPropagation();
          setUiState({
            ...uiState,
            shown: true
          });
        }}
      >
        <div className="p_x_sol_head_bg">
          <div className="p_x_sol_head_brand p_content-block--brand" />
        </div>

        <div className="p_x_sol_head_fg">
          <div className="p_formgroup_sm">
            <div className="p_x_sol_head0">
              <div className="p_x_sol_head0">
                <div className="t_h2">
                  <div>Level up your Xsolla integration</div>
                </div>
                <div className="p_x_sol_ind hidden">
                  <div>4</div>
                </div>

                <div className="p_x_sol_right">
                  <div>
                    <div
                      className="p_modal_collapse"
                      onClick={e => {
                        e.stopPropagation();
                        if (uiState.shown) {
                          setUiState({
                            shown: false,
                            all: false
                          });
                        } else {
                          setUiState({
                            shown: true,
                            all: false
                          });
                        }
                      }}
                    >
                      <div className="w-embed">
                        {uiState.shown && (
                          <svg width={24} height={24} viewBox="0 0 24 24">
                            <path
                              fill="currentColor"
                              d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
                            />
                            <path d="M0 0h24v24H0z" fill="none" />
                          </svg>
                        )}
                        {!uiState.shown && (
                          <svg width={24} height={24} viewBox="0 0 24 24">
                            <path
                              fill="currentColor"
                              d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
                            />
                            <path d="M0 0h24v24H0z" fill="none" />
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {(!limit || limit >= 4) && (
                <div
                  className="p_x_sol_right"
                  onClick={e => {
                    e.stopPropagation();
                    // if (!uiState['all']) window.scrollBy(0, 200)
                    setUiState({
                      shown: true,
                      all: !uiState["all"]
                    });
                  }}
                >
                  <div className="p_x_sol_all">
                    {uiState["all"] && (
                      <div className="p_button p_button--appearance-flatten t_white">
                        <div>show Less</div>
                      </div>
                    )}

                    {!uiState["all"] && (
                      <div className="p_button p_button--appearance-flatten t_white">
                        <div>show More</div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <CSSsolcont shown={uiState.shown}>
        <div className="p_formgroup_xs">
          <div className="p_modal_c p_modal_c--solutions">
            <div className="p_formgroup_xs">
              <div className="collection-list-wrapper w-dyn-list">
                <PAsolutionCards
                  shown={uiState.shown}
                  uiState={uiState}
                  limit={limit}
                  hardlimit={hardlimit}
                  solutions={solutions}
                />
              </div>
            </div>
          </div>
        </div>
      </CSSsolcont>

      {/* </div> */}
    </FormGroup>
  );
}

const CSSsolcont = styled.div`
  transition: all 450ms ease-in-out;
  width: 100%;
  overflow: hidden;
  max-height: ${props => (props.shown ? "3000px" : "0px")};
`;
const CSScard = styled.div`
  /* min-height: 510px; */
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  & .xsui-card {
    flex-grow:1;
    box-shadow: -1px 2px 13px -3px rgba(26, 44, 65, 0.33);
  }
  & .xsui-card-with-image {
    flex-grow:1;
  }
  & .xsui-card-with-image__image {
    width: calc(100% + 64px);
  }
`;







